import { PhotoSwipeLightbox } from "vendor";

function registerEditorialCarrouselLightboxUi(lightbox) {
  const pswp = lightbox.pswp;
  pswp.ui.registerElement({
    name: "close-button",
    className: "circle-button circle-button--xl hover:animate-icon-block",
    ariaLabel: window.themeVariables.strings.closeGallery,
    order: 2,
    isButton: true,
    html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
          <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>
        </svg>
      `,
    onClick: () => {
      pswp.close();
    }
  });
  if (pswp.options.dataSource.length > 1) {
    pswp.ui.registerElement({
      name: "previous-button",
      className: "circle-button hover:animate-icon-inline",
      ariaLabel: window.themeVariables.strings.previous,
      order: 1,
      isButton: true,
      html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      `,
      onClick: () => {
        pswp.prev();
      }
    });
    pswp.ui.registerElement({
      name: "next-button",
      className: "circle-button hover:animate-icon-inline",
      ariaLabel: window.themeVariables.strings.next,
      order: 3,
      isButton: true,
      html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      `,
      onClick: () => {
        pswp.next();
      }
    });
  }
}

class EditorialCarrouselLightbox extends HTMLElement {
  constructor() {
    super();
    this._photoSwipe = null;
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    if (this._photoSwipe && typeof this._photoSwipe.destroy === "function") {
      this._photoSwipe.destroy();
    }
    this._photoSwipe = null;
  }

  get lightbox() {
    if (this._photoSwipe) {
      return this._photoSwipe;
    }
    this._photoSwipe = new PhotoSwipeLightbox({
      pswpModule: () => import("photoswipe"),
      bgOpacity: 1,
      maxZoomLevel: 3,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      close: false,
      zoom: false
    });
    this._photoSwipe.on("uiRegister", () => registerEditorialCarrouselLightboxUi(this._photoSwipe));
    this._photoSwipe.addFilter("thumbEl", (thumbEl, data) => data.thumbnailElement);
    this._photoSwipe.init();
    return this._photoSwipe;
  }

  _onClick(event) {
    const btn = event.target.closest(".ehc__lightbox-btn");
    if (!btn || !this.contains(btn)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const frame = btn.closest(".ehc__frame");
    const img = frame?.querySelector(":scope > img");
    if (!img) {
      return;
    }
    const images = [...this.querySelectorAll(".ehc__slide .ehc__frame > img")];
    const index = images.indexOf(img);
    if (index < 0) {
      return;
    }
    const dataSource = images.map((image) => {
      const frame = image.closest(".ehc__frame");
      const hiSrc = frame?.dataset.hiSrc;
      const hiW = parseInt(frame?.dataset.hiW || "0", 10);
      const hiH = parseInt(frame?.dataset.hiH || "0", 10);
      const width = hiW || parseInt(image.getAttribute("width"), 10) || image.naturalWidth;
      const height = hiH || parseInt(image.getAttribute("height"), 10) || image.naturalHeight;
      return {
        thumbnailElement: image,
        src: hiSrc || image.src,
        srcset: hiSrc ? undefined : image.srcset,
        msrc: image.currentSrc || image.src,
        width,
        height,
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.lightbox.loadAndOpen(index, dataSource);
  }
}

if (!window.customElements.get("editorial-carrousel-lightbox")) {
  window.customElements.define("editorial-carrousel-lightbox", EditorialCarrouselLightbox);
}
